import { ReactComponent as Sport } from '../../icons/layers/sport2.svg'
import { ReactComponent as Language } from '../../icons/layers/language.svg'
import { ReactComponent as Epam } from '../../icons/layers/epam.svg'
import { ReactComponent as Epamers } from '../../icons/layers/epamers.svg'
import { ReactComponent as Realty } from '../../icons/layers/realty.svg'
import { ReactComponent as Health } from '../../icons/layers/health.svg'
import { ReactComponent as School } from '../../icons/layers/school.svg'
import { ReactComponent as Shop } from '../../icons/layers/shop.svg'
import { ReactComponent as Restaurant } from '../../icons/layers/restaurant.svg'
import { ReactComponent as Hotels } from '../../icons/layers/hotels.svg'
import { ReactComponent as Leisure } from '../../icons/layers/leisure.svg'
import { ReactComponent as Office } from '../../icons/layers/office.svg'
import { ReactComponent as Kids } from '../../icons/layers/kids.svg'
import { ReactComponent as Pets } from '../../icons/layers/pets.svg'
import { ReactComponent as Government } from '../../icons/layers/government.svg'
import { ReactComponent as Finance } from '../../icons/layers/finance.svg'
import { ReactComponent as Utilities } from '../../icons/layers/utilities.svg'
import { ReactComponent as Food } from '../../icons/layers/food.svg'
import { ReactComponent as Culture } from '../../icons/layers/culture.svg'
import { ReactComponent as Auto } from '../../icons/layers/auto.svg'
import { ReactComponent as Danger } from '../../icons/layers/danger.svg'
import { AnyObject, LayerResponse, MappedLayer } from '../../constants/types'

const getMappedLayer = (layer: LayerResponse): MappedLayer => {
  const ICON_SIZE = 14
  const iconSizes = { height: ICON_SIZE, width: ICON_SIZE }

  const icons = {
    1: <Sport {...iconSizes} />,
    2: <School {...iconSizes} />,
    4: <Leisure {...iconSizes} />,
    5: <Restaurant {...iconSizes} />,
    6: <Epamers {...iconSizes} />,
    7: <Office {...iconSizes} />,
    8: <Hotels {...iconSizes} />,
    9: <Language {...iconSizes} />,
    10: <Epam {...iconSizes} />,
    11: <Realty {...iconSizes} />,
    12: <Health {...iconSizes} />,
    13: <Kids {...iconSizes} />,
    14: <Pets {...iconSizes} />,
    15: <Government {...iconSizes} />,
    16: <Finance {...iconSizes} />,
    17: <Utilities {...iconSizes} />,
    18: <Food {...iconSizes} />,
    19: <Culture {...iconSizes} />,
    20: <Auto {...iconSizes} />,
    21: <Danger {...iconSizes} />,
    76: <Shop {...iconSizes} />,
    default: <Sport {...iconSizes} />,
  } as AnyObject

  return {
    id: layer.id,
    name: layer.name,
    parentId: layer.parentId,
    showPriority: layer.showPriority,
    icon: () => icons[layer.id],
    selected: false,
  }
}

export const getMappedLayers = (layers: LayerResponse[] | undefined) =>
  layers
    ?.map((layer) => {
      const mappedLayer = getMappedLayer(layer)

      return {
        id: mappedLayer.id,
        name: mappedLayer.name,
        parentId: mappedLayer.parentId,
        showPriority: mappedLayer.showPriority,
        selected: mappedLayer.selected,
        icon: mappedLayer.icon,
      }
    })
    .sort((layerA, layerB) => layerA.showPriority - layerB.showPriority)
